import axios from "axios";
import { protocol, url } from "../Urls";

export const getBotData = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      baseURL: `${protocol}${url}`,
      url: `/getBot?bot_id=${data["bot_id"]}&url=${data["url"].replace(/^https?:\/\//, '').replace(/^http?:\/\//, '')}`,
    })
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const runCustomBot = (data) => {
    return new Promise((resolve, reject) => {
      axios({
        headers: {
          "Access-Control-Allow-Origin": "*",
        },
        method: "post",
        baseURL: `${protocol}${url}`,
        url: "/runCustomBot",
        data: data,
      })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };